import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApiPbxManagerService} from "./services/api-pbx-manager.service";
import {PbxDashboardComponent} from './pbx-dashboard/pbx-dashboard.component';
import {SharedModule} from "../shared/shared.module";
import {DxButtonModule, DxDataGridModule, DxLoadIndicatorModule, DxTemplateModule, DxListModule} from "devextreme-angular";
import {DxiColumnModule} from "devextreme-angular/ui/nested";
import {LiveViewModule} from "../live-view/live-view.module";
import {SvgIconComponent} from "angular-svg-icon";
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PbxManager} from "./services/pbx-manager";
import {RouterModule} from '@angular/router';


@NgModule({
    declarations: [
        PbxDashboardComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        DxButtonModule,
        DxDataGridModule,
        DxLoadIndicatorModule,
        DxTemplateModule,
        DxListModule,
        DxiColumnModule,
        LiveViewModule,
        SvgIconComponent,
        DragDropModule
    ],
    providers: [{provide: PbxManager, useClass: ApiPbxManagerService}]
})
export class PbxModule {
}
